import { Component } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { CacBaseDialogComponent, CacDialogLayoutComponent } from '@controladad/ng-base';

export interface CropperDialogData {
  file: File;
  aspectRatio: number;
}

export type CropperDialogResult = File;

@Component({
  selector: 'featue-cropper-dialog',
  standalone: true,
  imports: [CacDialogLayoutComponent, ImageCropperComponent],
  templateUrl: './cropper-dialog.component.html',
  styleUrl: './cropper-dialog.component.scss'
})
export class CropperDialogComponent extends CacBaseDialogComponent<CropperDialogData, CropperDialogResult> {
  croppedImage?: Blob | null;

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.blob;
  }

  onSubmit() {
    if (!this.croppedImage) return;
    this.submit(new File([this.croppedImage], this.data.file.name));
  }
}
